define('SEOImprovements.HeaderLogo.View', [
    'Header.Logo.View',
    'underscore',
    'SC.Configuration'
], function SEOImprovementsHeaderLogoView(
    HeaderLogoView,
    _,
    Configuration
) {
    'use strict';

    _.extend(HeaderLogoView.prototype, {
        getContext: _.wrap(HeaderLogoView.prototype.getContext, function onGetContext(fn) {
            var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
            if (Configuration.get('header.logoUrl')) {
                originalRet.logoUrl = Configuration.get('header.logoUrl');
            }

            originalRet.siteName = originalRet.headerLinkTitle || Configuration.get('siteTitle');
            return originalRet;
        })
    });
});
